
import React, { useEffect, useState } from "react";
import moment from 'moment-jalaali'
import { Form, Select, Row, Col } from 'antd';
// import DatePicker from 'react-datepicker2';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import ValidatorHelper from "../helpers/ValidatorHelper";
import { usePersistedStore } from "../../store/persisted-store";
import { useReportsStore } from "../../store/slices/createReportsSlice";

export default function SalesFilter() {
    const { getBranchNames, business, getCompanyNames } = usePersistedStore()

    const reports = useReportsStore()
    const branchNames = business.branchNames.data;
    const branchNamesLoading = business.branchNames.loading;
    const companyNames = business.companyNames.data;
const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const loading = reports.businessCompanySaleReport.loading;
    const Token = business.currentBusiness.token;

    useEffect(() => {
        getCompanyNames(Token);
        getBranchNames(Token);
    }, [])

    function convertToMoment(date) {
        return moment(date?.toDate()).format("YYYY-MM-DD");
    }

    function onFinish(values) {
        const params = {
            FromDate: convertToMoment(fromDate),
            ToDate: convertToMoment(toDate),
            BranchId: values.branch ? values.branch : null,
            CompanyId: values.company
        }
        reports.getBusinessCompanySaleReport({ param: params });
    }

    const layout = {
        lg: 5,
        md: 12,
        xs: 24
    }

    const btnLayout = {
        lg: 3,
        md: 12,
        xs: 24
    }

    return (
        <div>
            <Form
                className="sale-filter"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                initialValues={{
                    branch: null,
                    // company: params.CompanyId,
                    // fromDate: params.FromDate && moment(params.FromDate).subtract(1, 'months'),
                    // toDate: params.ToDate && moment(params.ToDate)
                }} onFinish={onFinish}>
                <Row gutter={[8]}>
                    <Col {...layout}>
                        <Form.Item
                            name='company'
                            label=" شرکت بیمه"
                            rules={ValidatorHelper.required(' انتخاب شرکت بیمه')}>
                            <Select
                                placeholder=" شرکت بیمه را انتخاب کنید."
                                disabled={!companyNames.length}>
                                {companyNames && companyNames.filter(name => !name.Disabled).map(name => {
                                    return <Select.Option key={name.EmpCompanyID} value={name.EmpCompanyID}>{name.Title}</Select.Option>
                                })}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col {...layout}>
                        <Form.Item
                            name='fromDate'
                            label='از تاریخ'
                            rules={ValidatorHelper.required('تاریخ')}>
                            <DatePicker
                                value={fromDate}
                                onChange={setFromDate}
                                calendar={persian}
                                locale={persian_fa}
                                format="YYYY/MM/DD"
                                inputClass="datepicker-input"
                                calendarPosition="bottom-right"
                                portal
                                zIndex={1070}
                            />
                        </Form.Item>
                    </Col>
                    <Col {...layout}>
                        <Form.Item
                            name='toDate'
                            label='تا تاریخ'
                            rules={ValidatorHelper.required('تاریخ')}>
                            <DatePicker
                                value={toDate}
                                onChange={setToDate}
                                calendar={persian}
                                locale={persian_fa}
                                format="YYYY/MM/DD"
                                inputClass="datepicker-input"
                                calendarPosition="bottom-right"
                                portal
                                zIndex={1070}
                            />
                        </Form.Item>
                    </Col>
                    <Col {...layout}>
                        <Form.Item
                            name='branch'
                            label="رشته بیمه">
                            <Select
                                loading={branchNamesLoading}
                                disabled={!branchNames?.length}>
                                <Select.Option key="all" value={null}>همه رشته  بیمه ها</Select.Option>
                                {branchNames && branchNames.filter(name => !name.Disabled).map(name => {
                                    return <Select.Option key={name.Id} value={name.Id}>{name.Title}</Select.Option>
                                })}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col {...btnLayout}>
                        <Form.Item label=" " colon={false}>
                            <button
                                disabled={loading} type="primary" className="btn btn-primary waves-effect waves-light" htmltype="submit">
                                جستجو&nbsp;&nbsp;&nbsp; <i className={loading ? "bx bx-loader bx-spin" : "fas fa-search"}></i>
                            </button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}